(function(window, document) {
    if (document.querySelector('.mediathek') !== null) {
        var offset = 0;
        var limit = 12;
        var loading = false;
        let currentRequest = null;
        let loadMoreMedia = true;
        const loadingIcon = document.querySelector('.mediathek-loading-icon');
        const mediathek = document.querySelector('.mediathek');

        /**
         * Load media
         */
        function loadMedia() {
            if (loading || !loadMoreMedia) {
                return;
            }
            loading = true;
            loadingIcon.classList.remove('d-none');

            var filterType = document.querySelector('.mediathek-filter-link__active').attributes.getNamedItem('data-filtertype').value;
            var searchTerm = document.querySelector('.mediathek-filter-searchterm').value;

            var url = window._AVENCY_BASE_actions.mediathek;
            if (filterType !== '') {
                url += '&filterType=' + filterType;
            }
            if (searchTerm !== '') {
                url += '&searchTerm=' + searchTerm;
            }
            url += '&offset=' + offset;
            url += '&limit=' + limit;

            var request = new XMLHttpRequest();
            request.open('GET', url, true);

            if (currentRequest instanceof XMLHttpRequest) {
                currentRequest.abort();
            }
            currentRequest = request;
            request.onload = function () {
                if (this.status >= 200 && this.status < 400 && this.response != '') {
                    const responseContent = this.response;
                    if (offset > 0) {
                        var newDom = document.createElement('div');
                        newDom.innerHTML = responseContent;
                        document.querySelector('.mediathek .mediathek-listing').appendChild(newDom);
                    } else {
                        document.querySelector('.mediathek .mediathek-listing').innerHTML = responseContent;
                    }
                    loadingIcon.classList.add('d-none');

                    if (!responseContent || responseContent === '<div class="row"></div>') {
                        loadMoreMedia = false;
                    }

                    new LazyEmbed({
                        elements: '[data-lazyembed="video"]',
                        overlayText: _AVENCY_BASE_translations.dsgvoCompliance.privacyPolicyHint.video.replace('{uri}', _AVENCY_BASE_pages.privacyPolicy),
                        excludeElements: ':not([data-allow="true"])',
                        includeElements: '[data-allow="true"]',
                        onInit: function (wrapper) {
                            const overlayText = wrapper.querySelector('.lazyembed__text');
                            overlayText.addEventListener('click', function () {
                                wrapper.closest('.lazyembed').dataset.modalTarget = "true";

                                if (!window.viewport.md.up) {
                                    $('#videoDsgvoModal').modal('show');
                                }
                            }, {passive: true});
                        }
                    });
                    $('.mediathek-video a').fancybox();
                    $('.mediathek-image a').fancybox();
                }
                loading = false;
                offset += limit;
            };
            request.send();
        }

        /**
         * Check if mediathek bottom is in viewport
         */
        function isInViewport() {
            var endlessScrollElement = document.querySelector('.mediathek .mediathek-endlessscroll');
            var bounding = endlessScrollElement.getBoundingClientRect();
            return (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }

        // Load first batch of media
        loadMedia();

        if (!mediathek.dataset.disableLoadingByScrolling) {
            window.addEventListener('scroll', function (event) {
                if (isInViewport()) {
                    loadMedia();
                }
            });
        }

        document.addEventListener('click', function(e) {
            for (var target = e.target; target && target != this; target = target.parentNode) {
                if (target.classList.contains('mediathek-filter-link')) {
                    Array.prototype.forEach.call(document.querySelectorAll('.mediathek-filter-link'), function (element) {
                        element.classList.remove('mediathek-filter-link__active');
                    });

                    target.classList.add('mediathek-filter-link__active');
                    offset = 0;
                    loading = false;
                    loadMedia();
                    break;
                }

                if (target.classList.contains('mediathek-filter-searchbutton')) {
                    offset = 0;
                    loading = false;
                    loadMedia();
                    break;
                }

            }
        }, false);

        document.querySelector('.mediathek-filter-searchterm').addEventListener('keydown', function(event) {
            if (event.keyCode == 13) {
                offset = 0;
                loading = false;
                loadMedia();
            }
        });
    }
})(window, document);
